// src/pages/JournalPage.jsx
import React, { useState } from 'react';

const JournalPage = ({ readings, onBack, onDelete, onView }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [confirmDelete, setConfirmDelete] = useState(null);

  const filteredReadings = readings.filter((r) =>
    r.spreadName?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleDeleteClick = (e, id) => {
    e.stopPropagation();
    setConfirmDelete(id);
  };

  const handleConfirmDelete = () => {
    if (confirmDelete) {
      onDelete(confirmDelete);
      setConfirmDelete(null);
    }
  };

  if (readings.length === 0) {
    return (
      <div className="page-container">
        <div className="journal-empty">
          <div className="journal-empty-icon">📖</div>
          <h2 className="page-title font-cinzel">Mi Diario de Lecturas</h2>
          <p className="page-subtitle">
            Aquí aparecerán todas las lecturas que guardes. Aún no tienes ninguna registrada.
          </p>
          <button onClick={onBack} className="main-button primary-button">
            ✨ Hacer mi primera lectura
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="journal-header">
        <h2 className="page-title font-cinzel">Mi Diario de Lecturas</h2>
        <p className="page-subtitle">
          Revisa tus lecturas anteriores y reflexiona sobre los mensajes recibidos.
          Tienes <strong>{readings.length}</strong> lectura{readings.length !== 1 ? 's' : ''} guardada{readings.length !== 1 ? 's' : ''}.
        </p>
      </div>

      {/* Search */}
      {readings.length > 3 && (
        <div className="journal-search-wrapper">
          <span className="search-icon">🔍</span>
          <input
            type="text"
            placeholder="Buscar por tipo de tirada..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="guide-search-input"
          />
        </div>
      )}

      {/* Readings List */}
      <div className="journal-list">
        {filteredReadings.map((reading) => (
          <div
            key={reading.id}
            className="journal-entry"
            onClick={() => onView(reading)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && onView(reading)}
          >
            <div className="journal-entry-header">
              <div className="journal-entry-meta">
                <h3 className="journal-entry-title font-cinzel">{reading.spreadName}</h3>
                <p className="journal-entry-date">
                  📅 {new Date(reading.date).toLocaleDateString('es-ES', {
                    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
                  })}
                </p>
                {reading.isAiPowered && (
                  <span className="journal-ai-badge">🔮 AI</span>
                )}
              </div>
              <button
                className="journal-delete-btn"
                onClick={(e) => handleDeleteClick(e, reading.id)}
                aria-label="Eliminar lectura"
                title="Eliminar"
              >
                🗑️
              </button>
            </div>
            <div className="journal-entry-cards">
              {reading.cards.map((card, index) => (
                <div key={index} className="journal-mini-card-wrapper">
                  <img
                    src={card.image}
                    alt={card.name}
                    className={`journal-mini-card ${card.isReversed ? 'journal-mini-card--reversed' : ''}`}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = 'https://placehold.co/60/1e1b4b/d8b4fe?text=🔮';
                    }}
                  />
                </div>
              ))}
            </div>
            {reading.interpretation && (
              <p className="journal-entry-preview">
                {reading.interpretation.replace(/<[^>]*>/g, '').substring(0, 120)}...
              </p>
            )}
          </div>
        ))}

        {filteredReadings.length === 0 && (
          <p className="guide-empty">No hay lecturas que coincidan con "{searchTerm}"</p>
        )}
      </div>

      <button onClick={onBack} className="main-button secondary-button back-btn">
        ← Volver al Inicio
      </button>

      {/* Confirm Delete Modal */}
      {confirmDelete && (
        <div className="modal-overlay" onClick={() => setConfirmDelete(null)}>
          <div className="modal-content modal-content--confirm" onClick={(e) => e.stopPropagation()}>
            <h3 className="font-cinzel" style={{ color: '#fcd34d', marginBottom: '1rem' }}>¿Eliminar lectura?</h3>
            <p style={{ color: '#ddd6fe', marginBottom: '1.5rem' }}>
              Esta acción no se puede deshacer.
            </p>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
              <button onClick={() => setConfirmDelete(null)} className="main-button secondary-button">Cancelar</button>
              <button onClick={handleConfirmDelete} className="main-button" style={{ background: '#dc2626', color: 'white' }}>Eliminar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default JournalPage;
